import React from "react";
import { Link } from "react-router-dom";
import {
  MdCheckCircle,
  MdInfo,
  MdWarningAmber,
  MdError,
  MdNotificationsNone,
  MdChevronRight,
} from "react-icons/md";

const typeMeta = {
  success: {
    label: "Success",
    icon: MdCheckCircle,
    className: "notification-item--success",
  },
  info: {
    label: "Info",
    icon: MdInfo,
    className: "notification-item--info",
  },
  warning: {
    label: "Warning",
    icon: MdWarningAmber,
    className: "notification-item--warning",
  },
  danger: {
    label: "Alert",
    icon: MdError,
    className: "notification-item--danger",
  },
  default: {
    label: "Notification",
    icon: MdNotificationsNone,
    className: "notification-item--default",
  },
};

const formatRelativeTime = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;

  const diffMinutes = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMinutes < 1) return "Baru saja";
  if (diffMinutes < 60) return `${diffMinutes} menit lalu`;
  if (diffHours < 24) return `${diffHours} jam lalu`;
  if (diffDays < 7) return `${diffDays} hari lalu`;

  return date.toLocaleDateString("id-ID", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const NotificationItem = ({ item }) => {
  const meta = typeMeta[item.type] || typeMeta.default;
  const Icon = meta.icon;

  return (
    <article
      className={`notification-item ${!item.read ? "is-unread" : ""} ${meta.className}`}
    >
      <div className="notification-item__icon-wrap">
        <div className="notification-item__icon">
          <Icon size={20} />
        </div>
      </div>

      <div className="notification-item__content">
        <div className="notification-item__head">
          <div>
            <div className="notification-item__title-row">
              <h3 className="notification-item__title">{item.title}</h3>
              {!item.read && <span className="notification-item__dot" />}
            </div>
            <div className="notification-item__meta">
              {meta.label} • {formatRelativeTime(item.createdAt)}
            </div>
          </div>
        </div>

        <p className="notification-item__message">{item.message}</p>

        <div className="notification-item__footer">
          <span className="notification-item__time">
            {formatRelativeTime(item.createdAt)}
          </span>

          {item.actionTo && item.actionLabel && (
            <Link to={item.actionTo} className="notification-item__action">
              {item.actionLabel}
              <MdChevronRight size={18} />
            </Link>
          )}
        </div>
      </div>
    </article>
  );
};

export default NotificationItem;
